/* import __COLOCATED_TEMPLATE__ from './new-cda-success.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();